import React, { useState, useContext } from 'react';
import './GroupRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TooltipMenu from '../TooltipMenu/TooltipMenu';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function GroupRow({ showDetail, group }) {
  const environmentContext = useContext(EnvironmentContext);
  const [tooltipMenuVisible, setTooltipMenuVisible] = useState(false);
  const { activeUser: user } = environmentContext;

  if (logComponent('GroupRow')) { console.debug('GroupRow render'); }

  const handleButtonClick = () => {
    if (logComponent('GroupRow')) { console.debug('GroupRow handleButtonClick'); }
    setTooltipMenuVisible(!tooltipMenuVisible);
  }

  const handleButtonBlur = () => {
    if (logComponent('GroupRow')) { console.debug('GroupRow handleButtonBlur'); }
    setTimeout(() => {
      setTooltipMenuVisible(false);
    }, 200);
  }

  const openDetailModal = () => {
    if (logComponent('GroupRow')) { console.debug('GroupRow openDetailModal'); }
    showDetail(group, 'detail');
  }

  const openDeleteModal = () => {
    if (logComponent('GroupRow')) { console.debug('GroupRow openDeleteModal'); }
    showDetail(group, 'delete');
  }


  return (
    <tr className="Group-Row">
      <td className="Group-Row__cell Group-Row__name-cell">
        <span className="Group-Row__name-text">{group.name}</span>
        {
          group.canCorrespond &&
          <React.Fragment>
            <br />
            <span className="Group-Row__can-correspond--mobile">
              <FontAwesomeIcon className="Group-Row__can-correspond" icon="comment" />
              <span className="Group-Row__correspond-text">Can correspond</span>
            </span>
          </React.Fragment>
        }
        {
          group.canImpersonate &&
          <React.Fragment>
            <br />
            <span className="Group-Row__can-impersonate--mobile">
              <FontAwesomeIcon className="Group-Row__can-impersonate" icon="eye" />
              <span className="Group-Row__impersonate-text">Can Mimic</span>
            </span>
          </React.Fragment>
        }
      </td>
      {
        user.groupTypeString === 'Facility' &&
        <td className="Group-Row__cell Group-Row__correspondence-cell">
          {
            group.canCorrespond ?
              <React.Fragment>
                <FontAwesomeIcon className="Group-Row__can-correspond" icon="comment" />
                <span className="Group-Row__correspond-text">Yes</span>
              </React.Fragment> :
              <React.Fragment>
                <FontAwesomeIcon className="Group-Row__cant-correspond" icon="comment-slash" />
                <span className="Group-Row__correspond-text">No</span>
              </React.Fragment>
          }
        </td>
      }
      {
        (user.groupTypeString === 'Corporate' || user.groupTypeString === 'Status Solutions') &&
        <td className="Group-Row__cell Group-Row__impersonate-cell">
          {
            group.canImpersonate ?
              <React.Fragment>
                <FontAwesomeIcon className="Group-Row__can-impersonate" icon="eye" />
                <span className="Group-Row__impersonate-text">Yes</span>
              </React.Fragment> :
              <React.Fragment>
                <FontAwesomeIcon className="Group-Row__cant-impersonate" icon="eye-slash" />
                <span className="Group-Row__impersonate-text">No</span>
              </React.Fragment>
          }
        </td>
      }
      <td className="Group-Row__cell Group-Row__details-cell">
        <div className="Group-Row__tooltip-wrapper">
          <button
            className="Group-Row__icon-btn"
            onClick={handleButtonClick}
            onBlur={handleButtonBlur}>
            <FontAwesomeIcon icon="ellipsis-h"></FontAwesomeIcon>
          </button>
          <TooltipMenu
            isVisible={tooltipMenuVisible}
            menuItems={[
              { text: 'Modify', onClick: openDetailModal },
              { text: 'Delete', onClick: openDeleteModal }
            ]}
            detailMethod={openDetailModal} />
        </div>

      </td>
    </tr>
  );
}